import * as React from "react";
import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";
import { Title, Subtitle } from "./elements/Typo";
import Tag from "../../components/Tag";
import { ActivityTypeDisplayMap } from "./types";
import ActivityTypeTag from "./elements/ActivityTypeTag";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc: string;
  title: string;
  typeMap: ActivityTypeDisplayMap;
  onClick?: () => void;
  nrOfCollections: number;
  texts: {
    collection: string;
    collections: string;
    view: string;
  };
  [key: string]: any;
  topRight?: React.ReactNode;
};

function AdminActivityTile(
  {
    style,
    className,
    imageSrc,
    title,
    typeMap,
    onClick,
    texts,
    topRight,
    nrOfCollections,
    ...rest
  }: Props,
  ref: any
) {
  return (
    <Tile
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
      {...rest}
    >
      <Top imageSrc={imageSrc}>
        <ActivityTypeTag {...typeMap.E_LEARNING} />
      </Top>
      <Bottom
        topLeft={
          <>
            <Title>{title}</Title>
            <Subtitle>
              {nrOfCollections}{" "}
              {nrOfCollections === 1 ? texts.collection : texts.collections}{" "}
            </Subtitle>
            <Tag text={texts.view} c={["grey", 7]} style={{ marginTop: 4 }} />
          </>
        }
        topRight={topRight}
      />
    </Tile>
  );
}

export default React.memo(React.forwardRef(AdminActivityTile), (prev, next) => {
  if (prev.title !== next.title) {
    return false;
  }

  if (prev.imageSrc !== next.imageSrc) {
    return false;
  }

  return true;
});
